module.exports = __webpack_public_path__ + "system/img/index-logo.d271e713.png";